module.exports = "../../app/cells/components/empty_search_link_suggestion_cell.rb";